import { api } from './api';

const getCurrentFrames = async (params) => {
    // Cache key'i customerId ile birleştir: aksi halde farklı müşteriler
    // statik 'Frames-getCurrentFrames' key'i üzerinden yanlış cache hit/miss alıyordu.
    const customerId = params?.customerId ?? 'anon';
    const response = await api({
        url: 'Frames/getCurrentFrames',
        method: 'GET',
        id: `Frames-getCurrentFrames-${customerId}`,
        cache: {
            ttl: 24 * 60 * 60 * 1000
        },
        params,
    });
    return response.data;
};

const saveFrame = async (data) => {
    const response = await api({
        url: 'Frames/add',
        method: 'POST',
        data,
    });
    return response.data;
};

const getList = async ({body, pageNumber = 1, pageSize = 10}) => {
    const response = await api({
        url: `Frames/getList`,
        method: 'GET',
        params: {
            page: pageNumber,
            pageSize,
            ...body,
        },
    });
    return response.data;
};

const getById = async (id) => {
    const response = await api({
        url: `Frames/getbyid`,
        method: 'GET',
        params: {
            id,
        },
    });
    return response.data;
};

const deleteFrame = async (id) => {
    const response = await api({
        url: `Frames/delete`,
        method: 'DELETE',
        params:{
            customerId: window.customerId
        },
        data: {
            id,
            customerId: window.customerId
        },
    });
    return response.data;
};

const updateFrame = async (data) => {
    const response = await api({
        url: `Frames/update`,
        method: 'PUT',
        data,
    });
    return response.data;
};

const framesServices = {
  getCurrentFrames,
  saveFrame,
  getList,
  getById,
  deleteFrame,
  updateFrame,
};

export default framesServices;
